import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import {
  getNonStructuredCoursesAction,
  getNonStructuredFormDataAction,
} from '../actions';

const {
  useLoader: useNonStructuredFormDataLoader,
  LoaderProvider: NonStructuredFormDataLoaderProvider,
} = createLoaderImp({
  action: getNonStructuredFormDataAction,
});

const {
  useLoader: useNonStructuredCoursesLoader,
  LoaderProvider: NonStructuredCoursesLoaderProvider,
} = createLoaderImp({
  action: getNonStructuredCoursesAction,
});

export {
  useNonStructuredFormDataLoader,
  NonStructuredFormDataLoaderProvider,
  useNonStructuredCoursesLoader,
  NonStructuredCoursesLoaderProvider,
};
